import { render, staticRenderFns } from "./iconPaintedRepresentation.vue?vue&type=template&id=053b5554"
import script from "./iconPaintedRepresentation.vue?vue&type=script&lang=js"
export * from "./iconPaintedRepresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports